import { render } from "./TestTag.vue?vue&type=template&id=e3f99068&scoped=true"
import script from "./TestTag.vue?vue&type=script&lang=js"
export * from "./TestTag.vue?vue&type=script&lang=js"

import "./TestTag.vue?vue&type=style&index=0&id=e3f99068&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f99068"]])

export default __exports__